/**
 * This will read environment variables for what was set at build time.
 * It works for now, we'll just need different builds for different environments.
 * @param {string} envvar The name of the build environment variable
 * @param {string} defaultValue A default value to use if the
 * @returns {string} The unprocessed envVar
 */
function getFromBuildEnv(envvar, defaultValue) {
  return envvar || defaultValue;
}

/**
 * The the config reads environment at build time.
 * @type {{
 *   IS_DEV: boolean,
 *   VERSION: string,
 *   WSC_ADDRESS: string,
 * }}
 *
 * The defaults here are for a development project so that the system can run
 * for all local enviornments. They are overridden in the production build.
 */
export const BuildConfig = {
  IS_DEV: import.meta.env.DEV,
  VERSION: getFromBuildEnv(
    import.meta.env.UIC_BUILD_VERSION,
    `${__GIT_SHA__}-dev`,
  ),
  WSC_ADDRESS: getFromBuildEnv(
    import.meta.env.UIC_BUILD_WSC_ADDRESS,
    "http://localhost:55001",
  ),
};
